import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function FacebookPixel() {
  const location = useLocation();
  const hasTrackedPumaHybrid = useRef(false);

  useEffect(() => {
    // Standard PageView (keep existing behavior)
    if (window.fbq) {
      window.fbq("track", "PageView");
    }

    // Check URL params for PUMA + Benzin/Hybrid combination
    const params = new URLSearchParams(location.search);
    const model = params.get("model");
    const fuel = params.get("fuel");
    const source = params.get("source") || "organic";

    const isPumaHybrid = model === "PUMA" && fuel === "Бензин/Хибрид";

    // Fire custom event only once per session
    if (isPumaHybrid && !hasTrackedPumaHybrid.current && window.fbq) {
      window.fbq("trackCustom", "PumaHybridView", {
        model,
        fuel,
        source,
        timestamp: Date.now(),
      });

      hasTrackedPumaHybrid.current = true;
    }
  }, [location.pathname, location.search]);

  return null;
}
